type LogLevel = "debug" | "info" | "warn" | "error";

const levels: LogLevel[] = ["debug", "info", "warn", "error"];

const getLogLevel = (): LogLevel => {
    const level = localStorage.getItem("logLevel") as LogLevel | null;
    return level && levels.includes(level) ? level : "error";
};

const shouldLog = (level: LogLevel): boolean => {
    const currentLevel = getLogLevel();
    const result = levels.indexOf(level) >= levels.indexOf(currentLevel);
    return result;
};

export const logger = {
    debug: (...args: unknown[]): void => {
        if (shouldLog("debug"))
            console.debug("[DEBUG]:", ...args);
    },
    info: (...args: unknown[]): void => {
        if (shouldLog("info"))
            console.info("[INFO]:", ...args);
    },
    warn: (...args: unknown[]): void => {
        if (shouldLog("warn"))
            console.warn("[WARN]:", ...args);
    },
    error: (...args: unknown[]): void => {
        if (shouldLog("error"))
            console.error("[ERROR]:", ...args);
    },

    setLevel: (level: LogLevel): void => {
        if (levels.includes(level)) {
            localStorage.setItem("logLevel", level);
            console.log(`✅ Log level set to "${level}"`);
        } else {
            console.warn(`⚠️ Unknown log level: ${level}`);
        }
    },
    getLevel: (): LogLevel => getLogLevel(),
    reset: (): void => {
        localStorage.removeItem("logLevel");
        console.log("🔄 Log level reset to default (error)");
    },
};

declare global {
    interface Window {
        logger?: typeof logger;
    }
}

if (typeof window !== "undefined") {
    window.logger = logger; // Теперь это абсолютно валидно и безопасно
}